// Init jquery, popper.js, & Bootstrap
try {
  window.Popper = require('popper.js').default;
  window.$ = window.jQuery = require('jquery');
  require('bootstrap');
} catch (e) { console.log(e); }

Popper.Defaults.modifiers.computeStyle.enabled = false;
